
import { Component, Prop, Vue } from 'vue-property-decorator';
import Themeable from 'vuetify/lib/mixins/themeable';
import WebsiteGroupRepositoryInterface, { WebsiteGroup } from '@/services/WebsiteGroup/interfaces';
import { Website } from '@/services/Website/interfaces';
import { UserInterface, UserRepoInterface } from '@/services/Users/Interfaces';

@Component({
  mixins: [
    Themeable,
  ],
  inject: [
    'websiteGroupRepository',
    'userRepository',
  ],
})
export default class ChangeGroupOwnerDialog extends Vue {
  @Prop() group!: WebsiteGroup;

  @Prop() mainWebsite!: Website;

  public visible: boolean = true;

  public loading: boolean = true;

  public owners: (UserInterface | { header: string } | { divider: boolean })[] = [];

  public newOwner: string = '';

  public websiteGroupRepository!: WebsiteGroupRepositoryInterface;

  public userRepository!: UserRepoInterface;

  public get valid(): boolean {
    return this.newOwner !== this.group.owner;
  }

  public checkDisabledItem(owner: string): boolean {
    return this.group.owner === this.newOwner;
  }

  public async created(): Promise<void> {
    try {
      const usersResponse = await this.userRepository.getAllUsers(0);
      const users: (UserInterface | { header: string } | { divider: boolean })[] = [{ header: 'Fenix' }];
      users.push(...usersResponse[0]);

      const hbOwners = await this.websiteGroupRepository.getHBOwners();
      users.push({ divider: true }, { header: 'Hostbill' });

      users.push(
        ...hbOwners.map((owner) => ({ id: owner, username: `HB ${owner}` } as unknown as UserInterface)),
      );


      this.owners = users;

      this.loading = false;

    } catch (err) {
      this.$errorDialog.show(err.message);
    }
  }

  public async changeOwner(): Promise<void> {
    this.$emit('changeOwner', this.newOwner);
    this.destroyComponent();
  }

  public destroyComponent(): void {
    this.$emit('close');
    this.visible = false;
    this.loading = true;
  }
}
